import { render } from "./UpdateComponent.vue?vue&type=template&id=1207a899"
import script from "./UpdateComponent.vue?vue&type=script&lang=js"
export * from "./UpdateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/UpdateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1207a899"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1207a899', __exports__)) {
    api.reload('1207a899', __exports__)
  }
  
  module.hot.accept("./UpdateComponent.vue?vue&type=template&id=1207a899", () => {
    api.rerender('1207a899', render)
  })

}


export default __exports__